import './SearchBox.scss';
function SearchBox(props) {
	return (
		<div className="SearchBox" style={{ borderRadius: props.rounded ? 25 : 6 }}>
			<i className="fa fa-search"></i>
			<input
				type="text"
				placeholder={props.placeholder || 'Search for vehicle'}
				onChange={(e) => props.onSearch(e.target.value)}
				style={{ borderRadius: props.rounded ? 25 : 0 }}
			/>
		</div>
	);
}
export default SearchBox;
